import React, { useState } from "react";
import styles from "./Projects.module.css";
import { Project } from "../../types";

interface ProjectsProps {
  projects: Project[];
}

const Projects: React.FC<ProjectsProps> = ({ projects }) => {
  const [activeProject, setActiveProject] = useState<number | null>(null);

  return (
    <section id="projects" className={styles.projects}>
      <div className="container">
        <div className={styles.sectionTitle}>
          <h2 className={styles.sectionTitleH2}>Our Projects</h2>
          <p className={styles.sectionTitleP}>
            A young, dynamic team delivering superior quality supply and service
            excellence through integrity, safety and reliability.
          </p>
        </div>
        <div className={styles.projectsGrid}>
          {projects.map((project) => (
            <div
              key={project.id}
              className={styles.projectCard}
              onMouseEnter={() => setActiveProject(project.id)}
              onMouseLeave={() => setActiveProject(null)}
            >
              <div className={styles.projectImageContainer}>
                <img
                  src={project.image}
                  alt={project.title}
                  className={styles.projectImage}
                />
                <h3
                  className={`${styles.alwaysVisibleTitle} ${
                    activeProject === project.id
                      ? styles.alwaysVisibleTitleHidden
                      : ""
                  }`}
                >
                  {project.title}
                </h3>
                <div
                  className={`${styles.projectOverlay} ${
                    activeProject === project.id
                      ? styles.projectOverlayActive
                      : ""
                  }`}
                >
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <br />
                  {project.scope && (
                    <p>
                      <strong>Scope:</strong> {project.scope}
                    </p>
                  )}
                  {project.equipment && (
                    <p>
                      <strong>Equipment:</strong> {project.equipment}
                    </p>
                  )}
                  {project.iso && (
                    <p>
                      <strong>ISO Implementation:</strong> {project.iso}
                    </p>
                  )}
                  {project.volume && (
                    <p>
                      <strong>Volume:</strong> {project.volume}
                    </p>
                  )}
                  {project.companies && (
                    <p>
                      <strong>No. of Companies:</strong> {project.companies}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
